module.exports = __webpack_public_path__ + "h5/img/nav4.30593003.png";